import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "112",
  height: "112",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M56 2c29.823 0 54 24.177 54 54s-24.177 54-54 54S2 85.823 2 56 26.177 2 56 2zM31.65 69.998h-4V82.5a2 2 0 0 0 1.85 1.995l.15.005h12.349v-4.002L31.65 80.5V70zm53 0h-4V80.5H69.999v4l12.651.001a2 2 0 0 0 1.995-1.85l.005-.15V69.998zM69.999 27.5v4H80.65V42h4V29.5a2 2 0 0 0-1.85-1.995l-.15-.005H69.999zm-28 0H29.65a2 2 0 0 0-1.995 1.85l-.005.15v12.498h4V31.5h10.349v-4z",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }